import {
  Box,
  CircularProgress,
  Dialog,
  DialogTitle,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import {
  CATEGORY_COLORS,
  ModuleModel,
} from "../../../data/models/modules/ModuleModel";

import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import TableBarIcon from "@mui/icons-material/TableBar";
import { useState } from "react";

interface ChangeModuleDialogProps {
  open: boolean;
  modules: ModuleModel[] | null; // ahora puede ser null
  onSelect: (moduleId: string) => Promise<void>;
  onClose: () => void;
}

export function ChangeModuleDialog({
  open,
  modules,
  onSelect,
  onClose,
}: ChangeModuleDialogProps) {
  const [internalLoading, setInternalLoading] = useState(false);

  const handleClick = async (id: string) => {
    setInternalLoading(true);
    await onSelect(id);
  };

  const isInitialLoading = modules === null;
  const isEmpty = modules?.length === 0;

  return (
    <Dialog
      open={open}
      onClose={internalLoading ? undefined : onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3, pb: 2 } }}
    >
      <DialogTitle sx={{ textAlign: "center", fontWeight: 700, pb: 1 }}>
        Cambiar a otro módulo
      </DialogTitle>

      {isInitialLoading && !internalLoading && (
        <Box sx={{ py: 4, textAlign: "center" }}>
          <CircularProgress />
          <Typography sx={{ mt: 1.5, opacity: 0.7 }}>
            Cargando módulos…
          </Typography>
        </Box>
      )}

      {internalLoading && (
        <Box sx={{ py: 4, textAlign: "center" }}>
          <CircularProgress />
          <Typography sx={{ mt: 2, opacity: 0.7 }}>
            Cambiando módulo…
          </Typography>
        </Box>
      )}

      {!internalLoading && !isInitialLoading && isEmpty && (
        <Box sx={{ py: 4, textAlign: "center" }}>
          <Typography sx={{ opacity: 0.7 }}>
            No hay módulos disponibles
          </Typography>
        </Box>
      )}

      {!internalLoading && !isInitialLoading && !isEmpty && (
        <Box
          sx={{
            px: 2,
            maxHeight: 330,
            overflowY: "auto",
          }}
        >
          {modules!.some((m) => m.category === "TABLE") && (
            <Box sx={{ mb: 1.5 }}>
              <Typography
                fontSize={13}
                fontWeight={700}
                sx={{ mb: 0.5, opacity: 0.7, pl: 0.5 }}
              >
                Mesas
              </Typography>
              <Grid container spacing={1.2}>
                {modules!
                  .filter((m) => m.category === "TABLE")
                  .map((m) => (
                    <Grid item xs={6} sm={4} key={m.id}>
                      <Paper
                        onClick={() => handleClick(m.id!)}
                        elevation={0}
                        sx={{
                          p: 1.5,
                          borderRadius: 2,
                          textAlign: "center",
                          cursor: "pointer",
                          transition: "0.15s",
                          bgcolor: "rgba(0,0,0,0.03)",
                          "&:hover": {
                            bgcolor: "rgba(0,0,0,0.07)",
                            transform: "scale(1.03)",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            width: 36,
                            height: 36,
                            borderRadius: "50%",
                            mx: "auto",
                            mb: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            bgcolor: CATEGORY_COLORS[m.category],
                            color: "white",
                          }}
                        >
                          <TableBarIcon fontSize="small" />
                        </Box>
                        <Typography fontWeight={600} fontSize={14}>
                          {m.name}
                        </Typography>
                        <Typography fontSize={11} sx={{ opacity: 0.6 }}>
                          Mesa
                        </Typography>
                      </Paper>
                    </Grid>
                  ))}
              </Grid>
            </Box>
          )}
          {modules!.some((m) => m.category === "DELIVERY") && (
            <Box sx={{ mt: 1.5 }}>
              <Typography
                fontSize={13}
                fontWeight={700}
                sx={{ mb: 0.5, opacity: 0.7, pl: 0.5 }}
              >
                Domicilios
              </Typography>
              <Grid container spacing={1.2}>
                {modules!
                  .filter((m) => m.category === "DELIVERY")
                  .map((m) => (
                    <Grid item xs={6} sm={4} key={m.id}>
                      <Paper
                        onClick={() => handleClick(m.id!)}
                        elevation={0}
                        sx={{
                          p: 1.5,
                          borderRadius: 2,
                          textAlign: "center",
                          cursor: "pointer",
                          transition: "0.15s",
                          bgcolor: "rgba(0,0,0,0.03)",
                          "&:hover": {
                            bgcolor: "rgba(0,0,0,0.07)",
                            transform: "scale(1.03)",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            width: 36,
                            height: 36,
                            borderRadius: "50%",
                            mx: "auto",
                            mb: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            bgcolor: CATEGORY_COLORS[m.category],
                            color: "white",
                          }}
                        >
                          <DeliveryDiningIcon fontSize="small" />
                        </Box>

                        <Typography fontWeight={600} fontSize={14}>
                          {m.name}
                        </Typography>

                        <Typography fontSize={11} sx={{ opacity: 0.6 }}>
                          Domicilio
                        </Typography>
                      </Paper>
                    </Grid>
                  ))}
              </Grid>
            </Box>
          )}
        </Box>
      )}
    </Dialog>
  );
}
